<div class="container popup-container">
    <div class="lang-sel-popup">
        <link href='https://fonts.googleapis.com/css?family=Noto Sans' rel='stylesheet'>
        <h1 class="lang-sel-header">
            <p><img src="../../assets/ic_close_grey.svg" alt="" class="close-selection-popup"
                    (click)="closeLanguageSelectionPopup()"></p>
            <p>{{ 'translateStrings.select_your_preferred_language' | translate }}</p>
        </h1>
        <div class="list-layout">
            <ul>
                <li *ngFor="let lang of languages" class="list-item">
                    <div (click)="onLanguageSelection(lang.iso6391)" class="lang-opt">
                        <div>
                            <input type="radio" value="{{lang.name}}" [(ngModel)]="defaultSelectedLanguage"
                                name="languages" (change)="onLanguageSelection(lang.iso6391)" />
                            <label class="lang-main-text">{{lang.name}}</label>
                        </div>
                        <div>
                            <label class="lang-sub-text">{{languagesSubText[languages.indexOf(lang)]}}</label>
                        </div>
                    </div>
                    <hr *ngIf="languages.indexOf(lang) != languages.length-1" />
                </li>
            </ul>
        </div>
    </div>
</div>